// Track completed gestures, without coordinates or automatic camera movements.
export function setupMapAnalytics(map, lakeName, now = () => Date.now()) {
  let zoomInput = null;
  let panInput = null;
  let zoomStart = null;
  const container = map.getContainer();
  const markZoom = (source) => { zoomInput = { source, at: now() }; };
  container.addEventListener("wheel", () => markZoom("wheel"), { capture: true, passive: true });
  container.addEventListener("dblclick", () => markZoom("double_click"), true);
  container.addEventListener("touchstart", (event) => {
    if (event.touches.length >= 2) markZoom("pinch");
  }, { capture: true, passive: true });
  container.addEventListener("click", (event) => {
    if (event.target.closest(".leaflet-control-zoom a")) markZoom("zoom_button");
  }, true);
  container.addEventListener("keydown", (event) => {
    if (["+", "-", "=", "_"].includes(event.key)) markZoom("keyboard");
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.key)) {
      zoomInput = null;
      panInput = { source: "keyboard", at: now() };
    }
  }, true);
  const emit = (action, source, detail = {}) => {
    document.dispatchEvent(new CustomEvent("great-lakes-map-interaction", {
      detail: { action, source, zoom: map.getZoom(), lake: lakeName(map), ...detail },
    }));
  };
  map.on("dragstart", () => {
    zoomInput = null;
    panInput = { source: "drag", at: now() };
  });
  map.on("moveend", () => {
    // Leaflet moveend includes drag inertia. A zoom can also emit moveend.
    if (panInput && !zoomInput && now() - panInput.at < 60_000) emit("pan", panInput.source);
    panInput = null;
  });
  map.on("zoomstart", () => {
    zoomStart = zoomInput && now() - zoomInput.at < 1500
      ? { fromZoom: map.getZoom(), source: zoomInput.source } : null;
  });
  map.on("zoomend", () => {
    if (zoomStart && map.getZoom() !== zoomStart.fromZoom) {
      emit(map.getZoom() > zoomStart.fromZoom ? "zoom_in" : "zoom_out", zoomStart.source,
        { fromZoom: zoomStart.fromZoom });
    }
    zoomStart = null;
    zoomInput = null;
  });
}
